import React from 'react';
import styled from 'styled-components';
import CircularCheckIcon from '../../assets/icons/circular-check.svg';
import CustomButton from '../CustomButton/CustomButton';
import { useTranslation } from 'react-i18next';
const SaveDialogBodyConainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .circular__check {
    margin-bottom: 22px;
  }

  .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;

    text-align: center;
    letter-spacing: -1px;
  }

  p {
    text-align: center;
    word-break: break-word;

    @media only screen and (max-width: 768px) {
      width: 90%;
    }

    @media only screen and (min-width: 768px) {
      width: 80%;
    }

    @media only screen and (min-width: 1024px) {
      width: 70%;
    }
  }

  button {
    margin-top: 38px;
    margin-bottom: 54px;
  }
`;

const SaveDialogBody = ({ handleCloseIcon }) => {
  const  {t} = useTranslation()
  return (
    <SaveDialogBodyConainer>
      <img
        className="circular__check"
        src={CircularCheckIcon}
        alt="close"
        onClick={handleCloseIcon}
      />
      <h1 className="title">{t('Saved')}!</h1>
      <p>
        {t('Go Back to your monday.com board to send this document for E-Signing')}.
      </p>
      <CustomButton onClick={window.close}>{t('Close Window')}</CustomButton>
    </SaveDialogBodyConainer>
  );
};

export default SaveDialogBody;
